export const weddingWebsiteLocationSearchParam = 'wedding-website-onboarding';
